import React, { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import QRCode from "react-qr-code";
import { DHead, Lab } from "@/components/ms";

export const AppDownloadBanner = () => {
  const [isVisible, setIsVisible] = useState(() => {
    // Check if user has dismissed the banner
    return !localStorage.getItem("appDownloadBannerDismissed");
  });

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("appDownloadBannerDismissed", "true");
  };

  if (!isVisible) return null;

  const appStoreUrl = "https://apps.apple.com/app/moonscape"; // Replace with actual URL

  return (
    <section className="flex flex-col">
      <DHead
        label="Mobile app"
        right={
          <button
            type="button"
            onClick={handleDismiss}
            className="grid h-8 w-8 place-items-center text-ms-dim transition-colors hover:text-ms-ink"
            aria-label="Dismiss banner"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        }
      />

      <div className="mt-3.5 flex items-start gap-[var(--gap)]">
        <div className="min-w-0 flex-1">
          <h3 className="text-[15px] font-semibold tracking-[-0.015em]">
            Moonscape is even better in the app
          </h3>
          <p className="mt-1.5 text-[12.5px] leading-[1.5] text-ms-mute">
            Track your portfolio on the go, get notified as syncs finish, and read every
            tax report from your phone. iOS and Android, same data.
          </p>
          <Lab size={9} className="mt-2.5 block text-ms-dim">
            Scan to download
          </Lab>
        </div>

        <div className="flex-none border border-ms-line bg-white p-2.5">
          <QRCode value={appStoreUrl} size={96} level="M" />
        </div>
      </div>
    </section>
  );
};
